import { AtbLightTheme as BaseTheme, OmniTheme } from '@aiz-gl/omni-ui';

export const LightTheme: OmniTheme = {
  ...BaseTheme,
};
